// extracted by mini-css-extract-plugin
export default {"input-date":"dateinput_styles_input-date__u4U7k"};